export const messagesBusinessHours = {
    pt: {
        message:{
            closingTime: "Horário de fechamento",
            dayOfWeek: "Dia da semana",
            limitToBusinessHours: "Limitar ao horário de funcionamento",
            openingTime: "Horário de abertura"
        }
    },
    es: {
        message:{
            closingTime: "Horario de cierre",
            dayOfWeek: "Dia de la semana",
            limitToBusinessHours: "Limitación al horario comercial",
            openingTime: "Horario de apertura"
        }
    },
    en: {
        message:{
            closingTime: "Closing time",
            dayOfWeek: "Day of the week",
            limitToBusinessHours: "Limit to business hours",
            openingTime: "Opening time"

        }
    }
}
